// Chips de financieras (abreviatura, nombre y tono), como el `FIN_LABELS` del mock.
import { SaleFinancierEnum } from '@fiado/type-kit/bin/retailWizard/enums/SaleFinancierEnum';
import { financierKeyFromCode } from '../../store/lib/storeFormat';

/** Abreviatura y tono de cada financiera, como el `FIN_LABELS` del mock. */
const FINANCIER_CHIP: Record<string, { short: string; name: string; tone: string }> = {
    [SaleFinancierEnum.SUREKEEP]: { short: 'SK', name: 'SureKeep', tone: 'success' },
    [SaleFinancierEnum.PAYJOY]: { short: 'PJ', name: 'PayJoy', tone: 'info' },
    [SaleFinancierEnum.CREDIYA]: { short: 'CY', name: 'CrediYa', tone: 'warning' },
    [SaleFinancierEnum.LESPAGO]: { short: 'LP', name: 'LESPAGO', tone: 'muted' },
    [SaleFinancierEnum.INNOVA]: { short: 'INV', name: 'INNOVA', tone: 'muted' },
};

export interface FinancierChip {
    code: string;
    short: string;
    name: string;
    tone: string;
}

const SUREKEEP: string = SaleFinancierEnum.SUREKEEP;
const NO_FINANCIER: string = SaleFinancierEnum.NONE;

/** El código canónico; la grafía del catálogo («KREDIYA») cae en la financiera que nombra. */
export function canonicalFinancier(code: string): string {
    return financierKeyFromCode(code) ?? code;
}

/** Chips de financieras: SureKeep primero, como el mock; el resto alfabético. */
export function financierChips(financiers: string[]): FinancierChip[] {
    return [...new Set(financiers.map(canonicalFinancier))]
        .filter((code) => code !== '' && code !== NO_FINANCIER)
        .sort((a, b) => (a === SUREKEEP ? -1 : b === SUREKEEP ? 1 : a.localeCompare(b, 'es-MX')))
        .map((code) => ({
            code,
            ...(FINANCIER_CHIP[code] ?? { short: code, name: code, tone: 'muted' }),
        }));
}
